import { render, staticRenderFns } from "./CalendarioSeparacao.vue?vue&type=template&id=3d55add3"
import script from "./CalendarioSeparacao.vue?vue&type=script&lang=js"
export * from "./CalendarioSeparacao.vue?vue&type=script&lang=js"
import style0 from "./CalendarioSeparacao.vue?vue&type=style&index=0&id=3d55add3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports